import React from 'react';
import { isMobile } from 'react-device-detect';
import {
  ContainerProcedure,
  SubContainer
} from '../../../certificates-constancies/type1/info/components';
import { BackButton, InteractiveButton } from '../../../../components';
import Processing from '@/presentation/components/Processing';
import {
  ToggleHeader,
  TextTitle
} from '../../../certificates-constancies/type1/register/components';
import CardPayment from '../../Reincorporation/progress/components/CardPayment';
import Step from '../../UpdatePhoto/Register/components/Step';
import { Block, Text } from '../../../../../../components';
import { evalStatus } from './utils';
import InfoComponent from '../info/components/InfoComponent';
import Spinner from '@/presentation/components/Spinner';
import CancelProcedure from '../../CertificateOfStudies/dialogs/CancelProcedure';
import CardProgress from '@/presentation/reusables/CardProgress';
import TextHelper from '@/core/helpers/TextHelper';
import CardInProgress from '../../../certificates-constancies/type1/progress/components/CardInProgress';
import documentFailedImage from '../../../../../../../assets/illustrations/procedures/cards/document-failed.svg';
import documentFailedDskImage from '../../../../../../../assets/illustrations/procedures/cards/document-failed-dsk.svg';
import requestInProgressImage from '../../../../../../../assets/illustrations/request_in_progress.svg';
import requestInProgressDskImage from '../../../../../../../assets/icons/pse/RequestInProgress.svg';
import ModalConfirmation from '@/presentation/modules/procedures/components/Modal/Modal';
import ConfirmAction from '../../../certificates-constancies/type1/progress/components/ConfirmAction';

interface Props {
  handlerBackButton: () => void;
  request: any;
  procedure: any;
  isLoadingStatus: boolean;
  isLoadingDetail: boolean;
  handlerCancelProcedure: () => void;
  handlerActivatePayment: () => void;
  payment: {
    showModalPayment: boolean;
    setShowModalPayment: (value: boolean) => void;
  };
  anulatedPayment: {
    showModalAnuledPayment: boolean;
    setShowModalAnuledPayment: (value: boolean) => void;
  };
  isLoadingCancel: boolean;
  isLoadingActivatePayment: boolean;
  isPaymentDone: boolean;
  isSuccessActivatePayment: boolean;
  isPaymentActive: boolean;
  handlerDownload: () => void;
  academic: any;
  isComplete: boolean;
  CloseModal: () => void;
  goToPayment: () => void;
}

const GraduatedCertificatedProgressView: React.FC<Props> = (props) => {
  const { handlerBackButton, request, procedure, academic, isPaymentDone } =
    props;
  const { isLoadingStatus, isLoadingDetail, handlerCancelProcedure } = props;
  const { handlerActivatePayment, payment, anulatedPayment, isComplete } =
    props;
  const { showModalPayment, setShowModalPayment } = payment;
  const { showModalAnuledPayment, setShowModalAnuledPayment } = anulatedPayment;
  const { isLoadingCancel, isLoadingActivatePayment, isPaymentActive } = props;
  const { isSuccessActivatePayment, handlerDownload, CloseModal, goToPayment } =
    props;
  const isCreatedOrActived = ['CREADO', 'PAGO_ACTIVADO'].includes(
    request?.status?.status
  );

  const renderStatusCard = () => {
    const statusResult: any = evalStatus(request) || { name: 'PENDIENTE' }; // Fallback if evalStatus returns undefined
    const status = statusResult.name;
    if (status === 'FINALIZADO') {
      return (
        <CardInProgress
          availableDays={request?.expiredFile}
          activatePayment={false}
          paymentActivated={false}
          isFinished
          onClick={handlerDownload}
          textInfo
        />
      );
    }
    if (status === 'PAGO_REALIZADO') {
      return (
        <CardProgress
          SAE
          image={[requestInProgressImage, requestInProgressDskImage]}
          title="Tu solicitud está en proceso"
          subtitle="El estado del trámite se actualizará en unos minutos cuando tu constancia esté disponible para descargar."
        />
      );
    }
    return (
      <CardProgress
        image={[documentFailedImage, documentFailedDskImage]}
        title="Tu solicitud se ha anulado"
        subtitle="No pagaste a tiempo el monto de tu trámite."
      />
    );
  };

  return (
    <ContainerProcedure>
      <SubContainer>
        <BackButton onClick={handlerBackButton} />
      </SubContainer>
      <br />
      <Processing isOpen={isLoadingCancel || isLoadingActivatePayment} />
      {(isLoadingStatus || isLoadingDetail || !request) && <Spinner />}
      <ModalConfirmation
        show={showModalPayment && !isLoadingCancel && !isLoadingActivatePayment}
        handleClose={() => setShowModalPayment(false)}
      >
        <ConfirmAction
          activatePayment={request?.status.status === 'CREADO'}
          gotoPayment={request?.status.status === 'PAGO_ACTIVADO'}
          anulate={false}
          handleClickConfirm={handlerActivatePayment}
          handleClickCancel={() => setShowModalPayment(false)}
          amount={procedure?.amount}
        />
      </ModalConfirmation>
      <ModalConfirmation
        show={isSuccessActivatePayment}
        handleClose={CloseModal}
      >
        <ConfirmAction
          activatePayment={false}
          gotoPayment
          anulate={false}
          handleClickConfirm={goToPayment}
          handleClickCancel={CloseModal}
          amount={procedure?.amount}
        />
      </ModalConfirmation>
      <ModalConfirmation
        show={showModalAnuledPayment && !isLoadingCancel}
        handleClose={() => setShowModalAnuledPayment(false)}
      >
        <ConfirmAction
          activatePayment={false}
          gotoPayment={false}
          anulate
          handleClickConfirm={() => setShowModalAnuledPayment(false)}
          handleClickCancel={() => setShowModalAnuledPayment(false)}
          amount={procedure?.amount}
        />
      </ModalConfirmation>
      {request && (
        <SubContainer>
          <ToggleHeader
            isMigrated={procedure.detail.isMigrated}
            name={procedure.name}
            amount={procedure.amount}
            duration={procedure.duration}
            date={procedure.endDate}
            status={request.status}
            childContent={
              <InfoComponent
                steps={procedure.stepsToFollow}
                inRegister
                setShowModel={() => {}}
              />
            }
          />
          <TextTitle title="Progreso" />
          <Block customized padding="28px 0px 45px 8px">
            <Step
              isFirst
              name={procedure.steps[0].name}
              order={procedure.steps[0].order}
              date={procedure.steps[0].date.toLowerCase()}
              isComplete
              isCurrent={procedure.steps[0].isCurrent}
            >
              <div>
                <p>Datos validados para tu constancia:</p>
                <ul
                  style={{
                    listStyle: 'unset',
                    marginLeft: 20
                  }}
                >
                  <li>
                    Nombres y apellidos:{' '}
                    {TextHelper.capitalize(academic.profile.firstName)}{' '}
                    {TextHelper.capitalize(academic.profile.lastName)}
                  </li>
                  <li>
                    Carrera: {TextHelper.capitalize(academic.academic.progDesc)}
                  </li>
                </ul>
              </div>
            </Step>
            <Step
              name={procedure.steps[1].name}
              order={procedure.steps[1].order}
              isComplete={
                request.status.status === 'FINALIZADO' ||
                request.status.status === 'PROCEDE' ||
                request.status.status === 'PENDIENTE'
              }
              disabled={
                evalStatus(request)?.name === 'ANULADO' ||
                request.status.status === 'NO_PROCEDE'
              }
            >
              <>
                {evalStatus(request)?.name === 'CREADO' && (
                  <CardPayment
                    title="Genera el cargo de tu trámite activando tu pago"
                    infoText="Recuerda que una vez realizado el pago podrás descargar tu constancia."
                    buttonText="Activar"
                    isPaymentActive={isPaymentActive}
                    isPaymentDone={isPaymentDone}
                    handlerActivatePayment={handlerActivatePayment}
                    isLoadingActivatePayment={false}
                    isSuccessActivatePayment={false}
                    firstDialogSubtitle={`Al aceptar, se cargará el monto de S/${procedure.amount}.00 a tus pagos pendientes.`}
                  />
                )}
                {evalStatus(request)?.name === 'PAGO_ACTIVADO' &&
                  !isPaymentDone && (
                    <CardPayment
                      title="El pago ha sido activado"
                      infoText="Recuerda que una vez realizado el pago podrás descargar tu constancia. Completa el pago en un máximo de 3 días para evitar la anulación."
                      buttonText="Ir a pagos"
                      isPaymentActive
                      isPaymentDone={isPaymentDone}
                      handlerActivatePayment={handlerActivatePayment}
                      isLoadingActivatePayment={false}
                      isSuccessActivatePayment={isSuccessActivatePayment}
                      secondDialogSubtitle={
                        'Ya se encuentra disponible tu pago. Recuerda que una vez realizado el pago procederá tu solicitud.'
                      }
                    />
                  )}
                <Text fontSize="12px">
                  {isCreatedOrActived || evalStatus(request)?.name === 'ANULADO'
                    ? ''
                    : `Fecha de pago: ${procedure.steps[1].date.toLowerCase()}`}
                </Text>
              </>
            </Step>
            <Step
              name={procedure.steps[2].name}
              order={procedure.steps[2].order}
              isComplete={
                request.status.status === 'FINALIZADO' ||
                request.status.status === 'PROCEDE' ||
                request.status.status === 'ANULADO'
              }
              disabled={
                evalStatus(request)?.name === 'ANULADO'
                  ? false
                  : !procedure.steps[2].isCurrent
              }
              isLast
            >
              <Text fontSize="12px">
                {!isCreatedOrActived && (
                  <>
                    <p>
                      Fecha de solicitud:{' '}
                      {procedure.steps[0].date.toLowerCase()}
                    </p>
                    <p>
                      {request.status.name === 'Pendiente'
                        ? 'Fecha estimada de respuesta: '
                        : 'Fecha de respuesta: '}
                      {/* Fecha de respuesta:{' '} */}
                      {procedure.steps[1].date.toLowerCase()}
                    </p>
                  </>
                )}
              </Text>
              {(procedure.steps[2].isCurrent ||
                request.status.status === 'PAGO_REALIZADO') &&
                renderStatusCard()}
            </Step>
          </Block>
          {(evalStatus(request)?.name === 'CREADO' ||
            evalStatus(request)?.name === 'PAGO_ACTIVADO') &&
            !isComplete && (
              <Block style={{ alignSelf: isMobile ? 'center' : 'flex-start' }}>
                <InteractiveButton
                  data-testid="button-anullated-certificated"
                  bkgColorEnabled="none"
                  bkgColorHover="#E2DFFD"
                  bkgColorFocus="#C6C0FC"
                  bkgColorPressed="#C6C0FC"
                  customized
                  border="1px solid #5B36F2"
                  alignItems="center"
                  backgroundColor="#FFFFFF"
                  padding="9px 0px"
                  margin={isMobile ? '12px 0px 20px 0px' : '0px 0px 20px 0px'}
                  borderRadius="4px"
                  width="130px"
                  justifyContent={isMobile ? 'center' : 'flex-start'}
                  display="flex"
                  onClick={() => setShowModalAnuledPayment(true)}
                >
                  <Text
                    color="#5B36F2"
                    fontSize="14px"
                    lineHeight="20px"
                    fontWeight="700"
                    textAlign="center"
                    width="150px"
                  >
                    Anular solicitud
                  </Text>
                </InteractiveButton>
              </Block>
            )}
          <CancelProcedure
            handlerCancelProcedure={handlerCancelProcedure}
            handlerClose={() => setShowModalAnuledPayment(false)}
            show={showModalAnuledPayment}
          />
        </SubContainer>
      )}
    </ContainerProcedure>
  );
};

export default GraduatedCertificatedProgressView;
